import TranslationData from '@/models/TranslationData';

const translation: TranslationData = {
  search: {
    title: 'Sökning',
  },
  searchResults: {
    showMore: 'Visa fler resultat',
    noResults: 'Vi kunde tyvärr inte hitta några matchande sökresultat för din sökterm <b>{storeSearchTerm}</b>',
    noResultsHint: '',
    badges: {
      pfsc: '',
      fsc: '',
      fsc_pfsc: 'FSC® eller PEFC',
      ecofriendly: 'Miljömaterial',
      overnight: 'Express och Overnight',
      sameday: 'Sameday',
      express: 'Express',
      onlineDesign: 'Online design',
    },
    taglines: {
      home: 'Läs mer',
      text: 'Läs mer',
      themes: 'Läs mer',
      external: 'Läs mer',
      info: 'Läs mer',
      category: 'Läs mer',
      content: 'Läs mer',
      product: 'Anpassa nu',
    },
    headings: {
      categories: 'Produktkategorier',
      products: 'Produkter',
      external: 'Ytterligare information',
    },
    slider: {
      previousSlide: 'Visa tidigare innehåll',
      nextSlide: 'Visa nästa innehåll',
    },
  },
  searchInput: {
    inputTooShortError: 'Ditt sökord är för kort (min 2)',
    results: 'resultat',
    result: 'resultat',
    youSearchFor: 'Visar resultat för',
    suggestedTerm: {
      didYouMean: 'Menade du',
      resultsFor: 'Sök istället efter',
      didYouMeanPostFix: '?',
      resultsForPostFix: '-resultat',
    },
  },
  toolsBar: {
    buttons: {
      listButtonTooltip: 'Listvy',
      gridButtonTooltip: 'Kakelvy',
    },
    quickFilter: {
      filterChips: {
        clearAllFilters: 'Rensa alla filter',
        resetFilters: '',
      },
      buttonsPanel: {
        filterLabel: 'Filter',
        buttonsTooltipLabel: 'Se',
        resultLabel: 'Sökresultat',
      },
      contexts:
        {
          product: 'Produkter',
          content: 'Diverse',
          all: 'all',
          category: 'Produktkategorier',
          external: 'Ytterligare information',
        },
    },
    breadcrumbs: {
      start: 'Start',
      search: 'Sökning',
    },
  },
  sideBar: {
    filter: 'Filtrera',
    filterOverwrite: {
      category: {
        text: 'Kategorier',
      },
      rootCategory: {
        text: 'Kategorier',
      },
      specialFeatures: {
        text: 'Special Features',
        options: {
          logoFsc: 'FSC',
          logoPfsc: 'PFSC',
          logoFscPfsc: '',
          samedayAvailable: 'Same Day',
          expressAvailable: 'Express',
          overnightAvailable: 'Overnight',
          ecoFriendly: 'Eco Friendly',
          onlineDesign: 'Online design',
          new: 'New',
        },
      },
    },
    more: 'Show more',
    less: 'Show less',
  },
  common: {
    warnings: {
      server401: 'Din session har gått ut och du måste logga in igen. Du kommer att skickas vidare till inloggningen omedelbart.',
      server403: 'Begäran har inte tillämpats eftersom den saknar giltiga autentiseringsuppgifter. Vänligen ladda om sidan eller kontakta vår kundtjänst.',
      default: 'Det uppstod ett fel på servern. Vänligen ladda om sidan eller kontakta vår kundtjänst.',
    },
    errors: {
      server400: 'Begäran var felaktig. Vänligen ladda om sidan eller kontakta vår kundtjänst.',
      server404: '404 Sidan hittades inte. Gå till föregående sida eller kontakta vår kundtjänst.',
      server500: 'Det uppstod ett fel på servern. Vänligen ladda om sidan eller kontakta vår kundtjänst.',
      server501: 'Det uppstod ett fel på servern. Vänligen ladda om sidan eller kontakta vår kundtjänst.',
      server502: 'Det uppstod ett fel på servern och du får ett ogiltigt svar. Ladda om sidan eller kontakta vår kundtjänst.',
      server503: 'Det uppstod ett fel på servern. Ladda om sidan eller kontakta vår kundtjänst.',
      server504: 'Det uppstod ett fel på servern. Ladda om sidan eller kontakta vår kundtjänst.',
      default: 'Servern har ett problem med begäran. Vänligen ladda om sidan eller kontakta vår kundtjänst.',
    },
  },
};
export default translation;
